// middleware/auth-redirect.global.ts
import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useUserStore } from "~/stores/userstore";

export default defineNuxtRouteMiddleware((to, from) => {
  console.debug("postLoginCheck middleware");
  console.debug(to);
  console.debug(from);

  const userStore = useUserStore();
  if (userStore.auth && userStore.authUser) {
    console.debug(userStore.authUserUuid);
    const selectRegionRoute =
      "/users/" + userStore.authUserUuid + "/select-region";
    const isSelectRegionRoute =
      selectRegionRoute.toUpperCase() === to.path.toUpperCase();
    console.debug("isAddCountryRoute: ", isSelectRegionRoute);
    if (!isSelectRegionRoute) {
      if (userStore.authUser?.country == null) {
        console.debug("Redirecting to select region page");
        return navigateTo(
          "/users/" + userStore.authUser.uuid + "/select-region",
        );
      }
    }
  }
});
